import {STORE_CUSTOMER_LOAN} from '../../constants/loan';

const initialState = {
    customerLoanHistory: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_CUSTOMER_LOAN:
            return {
                ...state,
                customerLoanHistory: action.loanHistory
            }
        default:
            return state
    }
};
